import { EVENT_SAVED_SUCCESS } from '../actions/events';

const lastSavedEventId = (state = '', action) => {
  switch (action.type) {
    case EVENT_SAVED_SUCCESS:
      return action.eventId;
    default:
      return state;
  }
};

export default lastSavedEventId;



// WEBPACK FOOTER //
// ./src/redux/reducers/lastSavedEventId.js